module.exports = __webpack_public_path__ + "img/full4-min.ffa56c54.png";